import { DEFAULT_FULL_PARAMS, FULL_PARAM_DEFS, NormalizeFullParams } from '../../../constants/fullShipment';
import { useTokens } from '../../tokens';
import { PSection, usePresetBuilder } from '../context.jsx';

/**
 * FullParams — seção "Envio Full" do PresetBuilder.
 *
 * Edita `draft.full` (bloco snake_case persistido no payload do preset).
 * Sem o bloco, o preset usa os defaults de `DEFAULT_FULL_PARAMS` — a UI
 * mostra os defaults e só grava quando o usuário mexe em algum campo.
 * "restaurar padrão" apaga o bloco (volta a herdar os defaults).
 *
 * As tags/colunas do Full são calculadas pra TODO preset (com o bloco dele
 * ou os defaults) — esta seção só muda os números.
 */
export function FullParams() {
    const T = useTokens();
    const { draft, patch } = usePresetBuilder();
    const raw = draft?.full && typeof draft.full === 'object' ? draft.full : null;
    const effective = NormalizeFullParams(raw);
    const targetDays = effective.minDays + effective.leadDays;

    const setParam = (key, value) => {
        const base = raw || { ...DEFAULT_FULL_PARAMS };
        patch({ full: { ...base, [key]: value === '' ? DEFAULT_FULL_PARAMS[key] : Number(value) } });
    };

    const action = raw ? (
        <button
            type="button"
            onClick={() => patch({ full: undefined })}
            style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                color: T.muted,
                fontSize: 11,
                padding: 0,
                outline: 'none',
            }}
        >
            restaurar padrão
        </button>
    ) : null;

    return (
        <PSection
            title="Envio Full"
            hint={`Alvo: ${targetDays} dias de venda (mínimo ${effective.minDays} + lead ${effective.leadDays}). Estoque do Full = ML total.`}
            action={action}
        >
            <div
                data-faid="Full_Params_Preset_Builder"
                style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 10px' }}
            >
                {FULL_PARAM_DEFS.map((def) => {
                    const value = raw && raw[def.key] !== undefined && raw[def.key] !== null ? raw[def.key] : '';
                    return (
                        <label key={def.key} style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                            <span style={{ fontSize: 11, color: T.ink, fontWeight: 500 }}>{def.label}</span>
                            <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <input
                                    type="number"
                                    min={def.min}
                                    max={def.max}
                                    step={1}
                                    value={value}
                                    placeholder={String(DEFAULT_FULL_PARAMS[def.key])}
                                    onChange={(e) => setParam(def.key, e.target.value)}
                                    title={def.hint}
                                    style={{
                                        width: 64,
                                        padding: '5px 8px',
                                        borderRadius: 4,
                                        border: `1px solid ${T.line}`,
                                        background: T.bg,
                                        color: T.ink,
                                        fontSize: 12,
                                        fontFamily: T.mono,
                                        outline: 'none',
                                    }}
                                />
                                <span style={{ fontSize: 10, color: T.subtle }}>{def.unit}</span>
                            </span>
                        </label>
                    );
                })}
            </div>
        </PSection>
    );
}
